module.exports = __webpack_public_path__ + "img/banner8.2b15b757.jpg";